export default "__VITE_ASSET__B5fZolV4__"